import { useMutation, useQueryClient } from "@tanstack/react-query";
import { analytics } from "#/lib/analytics";
import { classifyReferralError, createReferralCode } from "#/lib/api/referrals";
import { queryKeys } from "./query-keys";
import { useAuth } from "./use-auth";

export function useCreateReferralCode() {
	const queryClient = useQueryClient();
	const { userId } = useAuth();

	return useMutation({
		mutationFn: (code: string) => createReferralCode(code),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: queryKeys.auth.me(userId),
			});
			queryClient.invalidateQueries({
				queryKey: queryKeys.referrals.myStats(userId),
			});
			analytics.track("referral_code_created", {});
		},
		onError: (err) => {
			// "already set" means the server authoritatively holds a code
			// for this user (e.g. created in another tab). Refetch /auth/me
			// so the UI flips to the read-only view.
			if (classifyReferralError(err) === "already-set") {
				queryClient.invalidateQueries({
					queryKey: queryKeys.auth.me(userId),
				});
				queryClient.invalidateQueries({
					queryKey: queryKeys.referrals.myStats(userId),
				});
			}
		},
	});
}
